import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';

const siteHeights = {
  mobile: {
    ZPAR: 'auto',
    '24MX': '701px',
    UBPE: '701px'
  },
  desktop: {
    ZPAR: 'auto',
    '24MX': '746px',
    UBPE: '746px'
  },
  tablet: '736px'
};

const Container = styled.div`
  width: 100%;
  height: ${({ device, site }) => siteHeights[device]?.[site] || '746px'};
  background-color: ${select('neutralGray')};
  font-family: 'Hind';
  font-style: normal;
  padding-bottom: ${({ device }) => {
    if (device === 'mobile') return '32px';
    if (device === 'tablet') return '32px';
    return '56px';
  }};
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ device }) => (device === 'mobile' ? '25px' : '8px')};
  padding-top: ${({ device }) => (device === 'mobile' ? '32px' : '56px')};
`;

const Title = styled.div`
  width: 100%;
  font-weight: 600;
  font-size: ${({ device }) => (device === 'mobile' ? '24px' : '32px')};
  line-height: ${({ device }) => (device === 'mobile' ? '130%' : '48px')};
  text-align: center;
`;

const Subtitle = styled.p`
  width: ${({ device }) => (device === 'mobile' ? '332px' : '496px')};
  font-weight: 400;
  font-size: ${({ device }) => (device === 'mobile' ? '16px' : '18px')};
  line-height: ${({ device }) => (device === 'mobile' ? '26px' : '133%')};
  letter-spacing: -0.02em;
  text-align: center;
  white-space: break-spaces;
`;

const siteWidths = {
  desktop: {
    ZPAR: '562px',
    '24MX': '1064px',
    UBPE: '1064px'
  },
  tablet: {
    ZPAR: '562px',
    '24MX': '722px',
    UBPE: '722px'
  }
};

const CarouselContainer = styled.div`
  width: ${({ device, site }) => siteWidths[device]?.[site] || '100%'};
  margin: 0px auto;
  .react-multi-carousel-track {
    gap: ${({ device }) => (device === 'mobile' ? '0px' : '20px')};
    width: 251px;
    margin-left: ${({ device }) => {
      if (device === 'tablet') return '20px';
      if (device === 'mobile') return '14px';
      return '0';
    }};
  }
  ${({ device }) =>
    device === 'tablet' &&
    css`
      overflow: hidden;
      position: relative;
    `};
`;

export { Container, HeaderContainer, Title, Subtitle, CarouselContainer };
